import noop from '@gaia/util/noop/action'
import _new from '@app/serviceItem/action/new'
import create from '@app/serviceItem/action/create'
import edit from '@app/serviceItem/action/edit'
import detail from '@app/serviceItem/action/detail'
import submit from '@app/serviceItem/action/submit'
import bulk from '@app/serviceItem/action/bulk'
import index from '@app/serviceItem/action'
import location from '@app/serviceItem/action/location'
import submitFavorite from 'app/_shared/action/favorite/submit'
import successFavorite from 'app/_shared/action/favorite/success'

export default {
  index,
  own: noop,
  new: _new,
  create,
  edit,
  detail,
  location,
  equipmentDocumentation: noop,
  productDocumentation: noop,
  equipmentOptions: noop,
  submit,
  bulk,
  requests: noop,
  measurements: noop,

  submitFavorite,
  successFavorite,
}
